






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaMedlog} from '@/model/resource/CargaMedlog'
import {InputCargaMedlogSchema} from '@/schema/resource/CargaMedlog/InputCargaMedlogSchema'

@Component
export default class PersistCargaMedlogView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaMedlogSchema()
  cargaMedlog = new CargaMedlog()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaMedlog.getCargaMedlog(id)
    }

    $.await.done('getCargaMedlog')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaMedlog.persistCargaMedlog()
    await Helper.successAndPush('system.success.persist', '/carga-medlog/list')
  }
}
